import * as React from 'react';
import SamsungPayHeader from '../../components/common/SamsungPayHeader';
import SamsungPayBox from '../../components/common/SamsungPayBox';
import AccountBindingTabs from '../../components/AccountBindingTabs';
import Loading from '../../components/Loading';
import { useSelector } from 'react-redux';
import debug from 'debug';
import {useEffect} from 'react';

const log = debug('app:PcBridgePage');
export default function PcBridgePage() {
  const { hasCookies } = useSelector((state) => state.cookieDetails);

  useEffect(() => {
    log('NEW BIND ACCOUNT');
  }, []);

  return (
    <>
      <SamsungPayBox>
        <SamsungPayHeader headerMessage="pay.gsmpi.main.selectPaymentRequestMode" />
        {hasCookies === undefined ?  <Loading />  :  <AccountBindingTabs />}
      </SamsungPayBox>
    </>
  );
}